import { render } from "./ModalBills.vue?vue&type=template&id=15ae3c82&scoped=true"
import script from "./ModalBills.vue?vue&type=script&lang=js"
export * from "./ModalBills.vue?vue&type=script&lang=js"

import "./ModalBills.vue?vue&type=style&index=0&id=15ae3c82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ae3c82"]])

export default __exports__